/**
 * 描述：监测右侧内容滚动事件，tab变化
 * 日期：2019-06-25
 * 作者：xie.zhengyun
 */
"use strict";
angular.module("rollMonitorModule", [])
    .directive("rollMonitor", ["$timeout", function($timeout) {
        return {
            restrict: 'A',
            replace: false,
            template: '',
            transclude: false,
            scope: {
                selectedTab: "=",
                anchorEle: "=",
                checkRollFlag: "="
            },
            link: function(scope) {
                let interval = null, //定时器 
                    topValue = 0; //上次滚动条到顶部的距离 
                scrollFn();
                initDestroy();

                function initStatus() {
                    scope.status = {
                        elementHeightArr: scope.anchorEle.map((_item) => {
                            return $('#' + _item.value).outerHeight(true);
                        }),
                        elementTop: [],
                    }
                }

                function initData() {
                    let beforeTop = 0;
                    for (var i = 0; i < scope.status.elementHeightArr.length; i++) {
                        beforeTop = i == 0 ? 0 : beforeTop + scope.status.elementHeightArr[i - 1];
                        scope.status.elementTop[i] = beforeTop;
                    }
                }
                /**
                 * [initDestroy description] 初始化监听销毁事件
                 * @return {[type]} [description]
                 */
                function initDestroy() {
                    scope.$on("$destroy", function() {
                        $(".content_text_wrap").unbind("scroll");
                    });
                }
                /**
                 * [scrollFn description] 滚动监测变动
                 * @return {[type]}         [description]
                 */
                function scrollFn() {
                    var $parentEl = $(".content_text_wrap");
                    $parentEl.bind('scroll', function() {
                        scope.checkRollFlag = false;
                        initStatus();
                        initData();
                        if (interval == null) {
                            interval = setInterval(() => {
                                checkRoll()
                            }, 100);
                        }
                        $timeout(function() {
                            var scrollTop = $parentEl[0].scrollTop;
                            var offsetHeight = $parentEl[0].scrollHeight;
                            var clientHeight = $parentEl[0].clientHeight;
                            var bodyClientHeight = document.body.clientHeight;
                            topValue = scrollTop;
                            var len = scope.status.elementHeightArr.length;
                            for (let i = 0; i < len; i++) {
                                let min = scope.status.elementTop[i],
                                    max = scope.status.elementTop[i] + scope.status.elementHeightArr[i];
                                if (i == 0 && scrollTop < min) {
                                    scope.selectedTab = scope.anchorEle[i];
                                    return;
                                } else if (scrollTop > min - 50 && scrollTop < max - 50) {
                                    if (offsetHeight / bodyClientHeight > 1.5 && Math.abs(offsetHeight / (scrollTop + clientHeight) - 1) < 0.001) {
                                        scope.selectedTab = scope.anchorEle[len - 1];
                                        return
                                    }
                                    scope.selectedTab = scope.anchorEle[i];
                                    return;
                                }

                            }
                        }, 500)
                    })

                };
                /**
                 [checkRoll description] 判断滚动是否停止
                 * @return {[type]}         [description]
                 */
                function checkRoll() {
                    if ($(".content_text_wrap")[0].scrollTop == topValue) {
                        clearInterval(interval);
                        interval = null;
                        scope.checkRollFlag = true;
                    }
                }
            }
        }
    }]);